import script from "./CurrentSetup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentSetup.vue?vue&type=script&setup=true&lang=ts"

import "./CurrentSetup.vue?vue&type=style&index=0&id=7daa5e86&lang=scss"

const __exports__ = script;

export default __exports__